import { Interval, Zone } from "luxon";

export const intervalSetZone = (timeZone: Zone) => (interval: Interval) => {
  return Interval.fromDateTimes(interval.start.setZone(timeZone), interval.end.setZone(timeZone));
};
